import { render, staticRenderFns } from "./Hotwork.vue?vue&type=template&id=53f46420&scoped=true&"
import script from "./Hotwork.vue?vue&type=script&lang=js&"
export * from "./Hotwork.vue?vue&type=script&lang=js&"
import style0 from "./Hotwork.vue?vue&type=style&index=0&id=53f46420&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f46420",
  null
  
)

export default component.exports